const hostname = {
  production: 'https://image.whakarongorau.nz',
  test: 'https://test-image.whakarongorau.nz',
};

const IMAGE_UPLOAD_LIMIT = 5;
const IMAGE_MAX_SIZE = 20000000;
const VIDEO_MAX_SIZE = 200000000;
const IMAGE_RESIZE_WIDTH = process.env.IMAGE_RESIZE_WIDTH || 1539;
const IMAGE_RESIZE_HEIGHT = process.env.IMAGE_RESIZE_HEIGHT || 905;
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;

console.log(`config (ENV): ${ENV}`);

module.exports = {
  ENV,
  IMAGE_UPLOAD_LIMIT,
  IMAGE_MAX_SIZE,
  VIDEO_MAX_SIZE,
  IMAGE_RESIZE_WIDTH,
  IMAGE_RESIZE_HEIGHT,
  gtmTrackingCode: 'GTM-5ZRCJ88',
  isTest: ENV === 'test',
  isProd: ENV === 'production',
  isDebug: ENV !== 'production' && ENV !== 'test',
  hostname: hostname[ENV] || 'http://localhost',
  port: process.env.PORT || 8080,

};
